export default __webpack_public_path__ + "static/media/home-light-bg.f4b63d59.png";